import React from 'react'

const PlayfairCipherAlgo = () => {
    return (
        <div>
            <h3>Encryption:</h3>
            <ol>
                <li>Choose a keyword for the cipher. This keyword will determine the shift values for each letter in the plaintext.</li>
                <li>Take the plaintext message you want to encrypt.</li>
                <li>Repeat the keyword to match the length of the plaintext. For each letter in the plaintext:
                    <ol type='a'>
                        <li>Determine the alphabetical position of the letter (e.g., A=0, B=1, ..., Z=25).</li>
                        <li>Determine the shift value based on the corresponding letter in the keyword.</li>
                        <li>Add the shift value to the alphabetical position of the plaintext letter.</li>
                        <li>Take 'result mod 26' to handle wrapping around the alphabet.</li>
                        <li>Convert the resulting alphabetical position back to a letter.</li>
                    </ol>
                </li>
                <li>Append the resulting letter to the ciphertext.</li>
                <li>Repeat steps 3 for each letter in the plaintext until the entire message is encrypted.</li>
                <li>The resulting ciphertext is the encrypted message.</li>
            </ol>
            <br />
            <h3>Decryption:</h3>
            <ol>
                <li>Take the ciphertext you want to decrypt.</li>
                <li>Choose the same keyword that was used for encryption.</li>
                <li>Repeat the keyword to match the length of the ciphertext. For each letter in the ciphertext:
                    <ol type='a'>
                        <li>Determine the alphabetical position of the ciphertext letter.</li>
                        <li>Determine the shift value based on the corresponding letter in the keyword.</li>
                        <li> Subtract the shift value from the alphabetical position of the ciphertext letter.</li>
                        <li>. If the result is negative, add 26 to it.</li>
                        <li>. Convert the resulting alphabetical position back to a letter.</li>
                    </ol>
                </li>
                <li>Append the resulting letter to the plaintext.</li>
                <li>Repeat steps 3 for each letter in the ciphertext until the entire message is decrypted.</li>
                <li>The resulting plaintext is the decrypted message.</li>
            </ol>
        </div>

    )
}

export default PlayfairCipherAlgo